module.exports = __webpack_public_path__ + "assets/media/day29.6085bb28.mp3";